import { ImageFormat, getImagePath, ImageType, cdnService, MagicConfigMixin } from '@gig/magic-common';
import { __extends, __decorate, __metadata } from 'tslib';
import { Prop, Component, Mixins } from 'vue-property-decorator';
import { CtaStyle } from '@gig/magic-sdk';
import { PromotionsOptinMixin } from '../../mixins/promotions-optin.mixin.js';

/**
 * Promotion box containing basic information including promotion image, title,
 * description and a link to promotion page.
 */
var PromotionCardComponent = /** @class */ (function (_super) {
    __extends(PromotionCardComponent, _super);
    function PromotionCardComponent() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(PromotionCardComponent.prototype, "src", {
        get: function () {
            return this.getImage(ImageFormat.WEBP);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PromotionCardComponent.prototype, "avifSrcset", {
        get: function () {
            return this.getImageSrcset(ImageFormat.AVIF);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PromotionCardComponent.prototype, "webpSrcset", {
        get: function () {
            return this.getImageSrcset(ImageFormat.WEBP);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PromotionCardComponent.prototype, "ctas", {
        get: function () {
            if (!this.promotion) {
                return [];
            }
            return this.promotion.values.cta;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PromotionCardComponent.prototype, "showOptIn", {
        get: function () {
            return this.optIns.length === 1;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PromotionCardComponent.prototype, "optIns", {
        get: function () {
            return this.ctas.filter(function (_a) {
                var style = _a.style;
                return style === CtaStyle.OPTIN;
            });
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PromotionCardComponent.prototype, "linkCtas", {
        get: function () {
            return this.ctas.filter(function (_a) {
                var style = _a.style;
                return style === CtaStyle.LINK;
            });
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PromotionCardComponent.prototype, "hasOptedIn", {
        get: function () {
            var _this = this;
            // We don't support multiple opt ins on the same promo.
            if (!this.showOptIn) {
                return false;
            }
            if (!this.isLoggedIn || !this.optIns[0].roles) {
                return false;
            }
            return this.optIns[0].roles.every(function (role) {
                return _this.userRoles.includes(role);
            });
        },
        enumerable: false,
        configurable: true
    });
    PromotionCardComponent.prototype.onCtaClick = function (cta, event) {
        var _a;
        if (!this.isOptIn(cta) || this.hasOptedIn) {
            return;
        }
        event.preventDefault();
        this.optIn((_a = this.promotion) === null || _a === void 0 ? void 0 : _a.name, cta);
    };
    PromotionCardComponent.prototype.getImageSrcset = function (format) {
        return this.getImage(format) + ", " + this.getImage(format, true) + " 2x";
    };
    PromotionCardComponent.prototype.getImage = function (format, retina) {
        if (retina === void 0) { retina = false; }
        if (!this.promotion || !this.promotion.image) {
            return null;
        }
        var promotionImage = getImagePath(ImageType.PROMO_IMAGES, this.promotion.image);
        return cdnService.getImageUrl(promotionImage, {
            width: this.imageWidth,
            quality: 100,
            retina: retina,
            format: format,
        });
    };
    __decorate([
        Prop({ type: Object, default: function () { return ({}); } }),
        __metadata("design:type", Object)
    ], PromotionCardComponent.prototype, "promotion", void 0);
    __decorate([
        Prop(String),
        __metadata("design:type", String)
    ], PromotionCardComponent.prototype, "tag", void 0);
    __decorate([
        Prop({ type: Number, default: 380 }),
        __metadata("design:type", Number)
    ], PromotionCardComponent.prototype, "imageWidth", void 0);
    PromotionCardComponent = __decorate([
        Component({
            name: 'promotion-card',
        })
    ], PromotionCardComponent);
    return PromotionCardComponent;
}(Mixins(MagicConfigMixin, PromotionsOptinMixin)));

export default PromotionCardComponent;
